import { Component,  Input, OnInit } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { Session } from 'globals/store/programs.data';
import { removeUniqueStringFromList } from '../../helpers/helpers';
import { TagPanelData, TagType } from 'globals/store/tags.data';
import { sessionTagReselector } from '../../store/reselectors/sessions.reselector';
import { TagPanelComponent } from '../manage/tag-panel.component';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'session-tag-panel',
    template: `
<tag-panel *ngIf="!!session"
  [readOnly]="readOnly" 
  [tagData]="tagData" 
  (removeTag)="removeTag($event)" 
  (setTags)="setTags($event)"
></tag-panel>
`,
    standalone: true,
    imports: [TagPanelComponent, CommonModule],
})
export class SessionTagPanelComponent extends Wrapper<SessionTagPanelComponent> implements OnInit {
  @Input() session: Session
  @Input() programId: string
  @Input() readOnly: boolean
  tagData: TagPanelData

  ngOnInit() {
    this.subProp(this.store.select(sessionTagReselector, { sessionId: this.session.id, programId: this.programId }), 'tagData')
  }

  saveSession() {
    console.log("Saving session... ", jsonCopyObject(this.session))
    this.programService.updateSession(this.programId, this.session)
  }

  setTags({ tagType, ids }: { tagType: TagType, ids: string[] }) {
    switch (tagType) {
      case 'attendee':
        this.session.attendeeTags = ids
        break
      case 'workforce': 
        this.session.tags = ids
        break
      case 'performer':
        this.session.performerTags = ids
        break
      case 'sponsor':
        this.session.sponsorTags = ids
        break
      case 'exhibitor':
        this.session.exhibitorTags = ids
        break
      case 'resource':
        this.session.resourceTags = ids
        break
      default:
      console.log(`Missing case for type: ${tagType}`)
      return
    }
    this.saveSession()
  }

  removeTag({ tagType, id }: { tagType: TagType, id: string }) {
    switch (tagType) {
      case 'attendee': 
        removeUniqueStringFromList(this.session.attendeeTags, id)
        break
      case 'workforce': 
        removeUniqueStringFromList(this.session.tags, id)
        break
      case 'performer':
        removeUniqueStringFromList(this.session.performerTags, id)
        break  
      case 'sponsor':
        removeUniqueStringFromList(this.session.sponsorTags, id)
        break  
      case 'exhibitor':
        removeUniqueStringFromList(this.session.exhibitorTags, id)
        break
      case 'resource':
        removeUniqueStringFromList(this.session.resourceTags, id)
        break    
      default:
        console.log(`Missing case for type: ${tagType}`)
        return
    }
    this.saveSession()
  }



}



